"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var React = require("react");
var react_text_mask_1 = require("react-text-mask");
var semantic_ui_react_1 = require("semantic-ui-react");
var styled_1 = require("../../styled");
var toHTMLDataTags_1 = require("../../utils/toHTMLDataTags");
var InputWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var InlineInputLabel = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 0.2rem;\n  font-weight: 300;\n  font-size: 1rem;\n  display: block;\n  padding-left: 0.9rem;\n"], ["\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 0.2rem;\n  font-weight: 300;\n  font-size: 1rem;\n  display: block;\n  padding-left: 0.9rem;\n"])), function (props) { return props.theme.colors.black; });
var InputLabel = styled_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 4px;\n  font-weight: 800;\n  font-size: 1rem;\n"], ["\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 4px;\n  font-weight: 800;\n  font-size: 1rem;\n"])), function (props) { return props.theme.colors.black; });
var EnvirioTextField = function (_a) {
    var className = _a.className, _b = _a.dataTags, dataTags = _b === void 0 ? {} : _b, disabled = _a.disabled, focus = _a.focus, icon = _a.icon, iconPosition = _a.iconPosition, id = _a.id, inputMaskType = _a.inputMaskType, inputRef = _a.inputRef, isInline = _a.isInline, label = _a.label, labelSubtext = _a.labelSubtext, min = _a.min, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, step = _a.step, style = _a.style, sublabel = _a.sublabel, sublabelIcon = _a.sublabelIcon, sublabelstyle = _a.sublabelstyle, textalign = _a.textalign, textarea = _a.textarea, type = _a.type, value = _a.value;
    var componentProps = __assign(__assign({ className: className, disabled: disabled,
        focus: focus, id: id, name: name || '', onChange: onChange, placeholder: placeholder, readOnly: !!readOnly, ref: inputRef, step: step, style: style || {}, sublabelstyle: sublabelstyle || {}, type: type || 'text', value: value || '' }, toHTMLDataTags_1.toHTMLDataTags(dataTags)), { min: min,
        onBlur: onBlur });
    if (icon) {
        componentProps = __assign(__assign({}, componentProps), { icon: icon,
            iconPosition: iconPosition });
    }
    if (textarea && textalign) {
        componentProps.textalign = textalign;
    }
    var children;
    switch (inputMaskType) {
        case 'Phone':
            children = (React.createElement(react_text_mask_1.default, { guide: true, mask: [
                    '(',
                    /[1-9]/,
                    /\d/,
                    /\d/,
                    ')',
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ], name: name, onChange: onChange, placeholder: "(555) 555-5555", placeholderChar: '\u2000', value: value }));
            break;
        case 'Year':
            children = (React.createElement(react_text_mask_1.default, { guide: true, mask: [/\d/, /\d/, /\d/, /\d/], name: name, onChange: onChange, placeholder: "1900", placeholderChar: '\u2000', value: value }));
            break;
        default:
            break;
    }
    var input = React.createElement(semantic_ui_react_1.Input, __assign({}, componentProps, { children: children }));
    if (textarea) {
        input = React.createElement(semantic_ui_react_1.Form.TextArea, __assign({}, componentProps));
    }
    if (label) {
        return (React.createElement(InputWrapper, null,
            typeof label === 'string' && isInline ? (React.createElement(InlineInputLabel, null, label)) : typeof label === 'string' ? (React.createElement(InputLabel, null, label)) : (label),
            labelSubtext && labelSubtext,
            input,
            sublabel ? (React.createElement("span", { className: "sublabelIconWrapper", style: sublabelstyle },
                sublabelIcon && React.createElement(semantic_ui_react_1.Icon, { name: sublabelIcon, size: "small" }),
                sublabel)) : null));
    }
    return input;
};
var getBorderColor = function (_a) {
    var disabled = _a.disabled, error = _a.error, neutral = _a.neutral, primary = _a.primary, theme = _a.theme;
    if (disabled || neutral) {
        return 'none';
    }
    if (primary) {
        return "2px solid " + theme.colors.primary;
    }
    if (error) {
        return "2px solid " + theme.colors.error;
    }
    return "2px solid rgba(0,0,0,.25)";
};
var getLeftIconStyles = function (_a) {
    var error = _a.error, primary = _a.primary, theme = _a.theme;
    return "\n  opacity: " + (primary ? 1 : 0.25) + " !important;\n  color: " + (primary ? theme.colors.primary : theme.colors.black) + "\n";
};
var getTextAlignStyles = function (_a) {
    var textalign = _a.textalign, theme = _a.theme;
    if (theme.textalign.center) {
        return "center";
    }
    if (theme.textalign.right) {
        return "right";
    }
    return "left";
};
var getSublabelStyles = function (_a) {
    var sublabelIconVariant = _a.sublabelIconVariant, sublabelVariant = _a.sublabelVariant, theme = _a.theme;
    return "\n  color: " + (sublabelVariant ? theme.colors[sublabelVariant] : theme.colors.black) + ";\n  & i {\n    color: " + (sublabelIconVariant
        ? theme.colors[sublabelIconVariant]
        : theme.colors.black) + ";\n  }\n";
};
var getBackgroundColor = function (_a) {
    var disabled = _a.disabled, neutral = _a.neutral, theme = _a.theme;
    if (disabled) {
        return 'rgba(0, 36, 45, 0.1) !important';
    }
    else if (neutral) {
        return 'rgba(0, 36, 45, 0.05) !important';
    }
    return theme.colors.white;
};
var getFontSize = function (fontSize) {
    if (!fontSize)
        return '';
    return "font-size: " + fontSize + " !important;";
};
var getFontWeight = function (fontWeight) {
    if (!fontWeight)
        return '';
    return "font-weight: " + fontWeight + " !important;";
};
var BaseTextField = styled_1.default(EnvirioTextField)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: 0.33rem !important;\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  margin-bottom: ", ";\n\n  & input {\n    ", " ", "\n    padding: 8px;\n    border-radius: 10px !important;\n    border: none !important;\n    text-align: ", " !important;\n    background-color: ", ";\n  }\n\n  & textarea {\n    text-align: ", ";\n    padding: 8px;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px !important;\n    border: none !important;\n  }\n"], ["\n  border-radius: 0.33rem !important;\n  height: ",
    ";\n  width: ",
    ";\n  background-color: ", ";\n  margin-bottom: ", ";\n\n  & input {\n    ", " ",
    "\n    padding: 8px;\n    border-radius: 10px !important;\n    border: none !important;\n    text-align: ", " !important;\n    background-color: ", ";\n  }\n\n  & textarea {\n    text-align: ", ";\n    padding: 8px;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px !important;\n    border: none !important;\n  }\n"])), function (props) {
    return props.isInline ? '3rem' : props.textarea ? 'auto' : '36px';
}, function (props) {
    return props.isInline ? '95%' : props.textarea ? 'auto' : '200px';
}, function (props) { return getBackgroundColor(props); }, function (props) { return props.isInline && '.6rem'; }, function (props) { return getFontSize(props.fontSize); }, function (props) {
    return getFontWeight(props.fontWeight);
}, function (props) { return props.textalign || 'left'; }, function (props) { return getBackgroundColor(props); }, function (props) { return (props.textalign ? props.textalign : 'left'); });
var getFocusWithinBorderStyles = function (props) {
    if (props.readOnly) {
        return "2px solid rgba(0,0,0,.25)";
    }
    if (!(props.primary || props.error || props.disabled)) {
        return "2px solid " + props.theme.colors.primary;
    }
    return getBorderColor(props);
};
exports.TextField = styled_1.default(BaseTextField)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  :focus-within {\n    border: ", ";\n\n    & textarea {\n      outline: none;\n    }\n  }\n\n  border: ", ";\n  color: ", ";\n  text-align: ", ";\n\n  & i {\n    ", ";\n  }\n\n  & span.sublabelIconWrapper {\n    ", ";\n  }\n"], ["\n  :focus-within {\n    border: ", ";\n\n    & textarea {\n      outline: none;\n    }\n  }\n\n  border: ", ";\n  color: ",
    ";\n  text-align: ", ";\n\n  & i {\n    ", ";\n  }\n\n  & span.sublabelIconWrapper {\n    ", ";\n  }\n"])), getFocusWithinBorderStyles, function (props) { return getBorderColor(props); }, function (props) {
    return props.disabled ? 'rgba(0, 36, 45, 0.25)' : props.theme.black;
}, function (props) { return getTextAlignStyles(props); }, function (props) { return getLeftIconStyles(props); }, function (props) { return getSublabelStyles(props); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map